import {
    executetreatOrderItem,
    getTreatOrderAllList, getTreatOrderItemList, getPatientListByName, clinicSqbTreatmentPay,
    clinicSqbTreatQueryResult
} from "@/api";
import {addDateRange, getCurrentDoctorId, message} from "@/assets/utils/common";
import baseConfig from "@/api/config";

/**
 * pending 自动轮询窗口（秒）。与后端扫码支付锁的 TTL 对齐
 * （ISqbOrderPayServiceImpl.SCAN_PAY_LOCK_MINUTES = 10 分钟）：
 * 窗口不得大于锁的 TTL —— 窗口先到点而锁还在，会出现「页面已转待人工核查、
 * 收银员想重扫却被锁挡住」的自相矛盾状态。两处必须一起改。
 */
const PAY_PENDING_WINDOW_SECONDS = 600;
/** pending 期间两次查单之间的间隔（秒） */
const PAY_PENDING_POLL_INTERVAL_SECONDS = 10;

export default {
    data() {
        return {
            currentPage: 1,
            pageNums: 20,
            totalCount: 0,
            tableLoading: false,
            tableData: [],
            treatOrderQueryVersion: 0,
            tableHeight: 500,
            treatOrderParams:{
                projectType: null, // 诊疗项目
                patientName: null, // 患者姓名
                diagnosis: null, // 诊断
                params: null
            },
            nameSelectConShow: false,
            patientRange: [],
            treatOrder: {
                dateTime: null, // 就诊时间
                avatarImg: null, // 医生头像
                dppId: null, // 医生建档的患者ID
                dppName: null, // 患者姓名
                dppSex: null, // 患者性别
                dppAge: null, // 患者年龄
                dppPhone: null, // 患者手机号
                dppIdentity: null, // 患者身份证
                dppAddress: null, // 患者身地址
                dppAllergyHistory: null, // 患者过敏史
                docId: null, // 医生ID
                diagnosis: null, // 诊断
                projectType: null, // 诊疗项目
                projectName: null, // 项目类型
                treatPrice: null, // 金额
                orderPrice: null, // 实收
                treatOrderItemList: [], // 检查治疗项目订单对应子项目记录信息
                remark: null, // 备注
            },

            treatLoading: false,
            treatOrderItem: {
                treatId: '',
            },
            treatItemData: [],
            treatmentItem: {
                itemType: null, // 项目类型
            },
            treatItemList: [],

            orderTableLoading: false,
            dateTime: null,
            dateOrderTime: '',
            orderTableHeight: 500,
            tencentCosUrl: baseConfig.tencentCosUrl,
            patientInfo: {
                avatarImg: null,
                name: null,
                sex: null,
                age: null,
                phoneNumber: null,
                identity: null,
                province: null,
                dppId: null,
                height: null,
                weight: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null
            },
            orderlist: [],
            patientId: null,
            direction: 'rtl',

            orderId: null,
            orderWarningInfo: null,
            fileLists: [],
            imageStyles: {
                width: 90,
                height: 120,
            },
            doctorInfo: {
                name: null,
                signPic: null,
                phoneNumber: null,
                docPriceHide: 0, // 诊费 0 显示  1 隐藏
            },
            printDate: null, // 打印日期
            treatOrderDetailVisible: false, // 检查治疗单详情弹窗
            payCodeList: [], // 预览的支付码
            printInfoObj: {
                id: 'printArea',
                popTitle: '知夏中医门诊部检查治疗单', // 打印配置页上方标题
                extraHead: '', //最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
                preview: '', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
                previewTitle: '知夏中医门诊部检查治疗单', // 打印预览的标题（开启预览模式后出现）,
                previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
                zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
                previewBeforeOpenCallback() {}, //预览窗口打开之前的callback（开启预览模式调用）
                previewOpenCallback() {}, // 预览窗口打开之后的callback（开启预览模式调用）
                beforeOpenCallback() {}, // 开启打印前的回调事件
                openCallback() {}, // 调用打印之后的回调事件
                closeCallback() {}, //关闭打印的回调事件（无法确定点击的是确认还是取消）
                url: '',
                standard: '',
                extraCss: '',
            },
            orderPayDialogVisible: false, // 订单收费弹窗
            payLoading: false, // 订单收费加载圈
            isWaitPayLoading: true, // 订单收费等待扫码
            isPayed: false, // 是否完成订单收费
            successPayed: true, // 是否支付成功
            payErrorMsg: "", // 支付失败错误信息（后端返回）
            payState: "", // 支付结果三态：success / pending / failed
            payChannel: "", // 支付成功渠道：SQB / CASH / FREE
            payRequesting: false, // 支付请求进行中，防止重复扫码发起第二笔扣款
            querying: false, // 「重新查询」进行中
            payPendingTimer: null, // pending 自动轮询定时器（1 秒 tick，同时驱动倒计时）
            payPendingRemain: 0, // pending 窗口剩余秒数
            payPendingExpired: false, // pending 窗口是否已到点（转「待人工核查」）
            removeScanListener: null // 用于存储移除扫码监听器的函数
        }
    },
    mounted() {
        this.resizeTableHeight();
        this.initScanListener();
    },
    created() {
        this.getTreatHistoryOrderList();
    },
    // 在 beforeUnmount 钩子中清理事件监听器（Vue 3 中 beforeDestroy 不会触发）
    beforeUnmount() {
        // 如果存在移除监听器的函数，则调用它
        this.stopPayPendingWatch();
        if (this.removeScanListener) {
            this.removeScanListener();
        }
    },
    computed: {
        // 三态文案：pending 绝不能被渲染成失败，否则会诱导收费员重复扫码
        payResultText() {
            if (this.payState === 'success') {
                return '已支付成功';
            }
            if (this.payState === 'pending') {
                // 窗口到点后转「待人工核查」：仍是「未确认」，绝不能说成失败
                return this.payPendingExpired ? '待人工核查' : '支付结果确认中';
            }
            return '支付失败';
        }
    },
    methods: {
        // 扫码枪扫描处理方法
        handleScanCode(code) {
            if (this.orderPayDialogVisible && this.isWaitPayLoading) {
                // 如果正在等待支付扫码，则处理支付码
                this.processPaymentCode(code);
            } else {
                // 其他情况可根据需要扩展
                console.log('扫描到条码:', code);
            }
        },

        // 处理支付码
        processPaymentCode(dynamicId) {
            if (!dynamicId) {
                message("扫描的条码无效", "error");
                return;
            }
            console.log("this.treatOrderItem.treatId >>>>" + this.treatOrderItem.treatId);
            console.log("treatOrder orderPrice >>>>" + this.treatOrder.orderPrice);
            console.log("dynamicId >>>>" + dynamicId);
            // AC12：请求未返回前不允许再次扫码，否则并发扫码会发起第二笔扣款
            if (this.payRequesting) {
                console.warn("上一笔支付请求尚未返回，忽略本次扫码");
                return;
            }
            this.payRequesting = true;
            // 新一次扫码：结束上一轮 pending 窗口
            this.stopPayPendingWatch();
            this.payPendingExpired = false;
            this.payPendingRemain = 0;
            this.payLoading = true;
            this.isPayed = false;
            this.payState = "";
            this.payChannel = "";
            this.payErrorMsg = "";
            let params = {
                orderId: this.treatOrderItem.treatId,
                price: this.treatOrder.orderPrice,
                dynamicId: dynamicId, // 条码内容
            };
            console.log("this.isWaitPayLoading >>>>" + this.isWaitPayLoading);
            console.log("this.payLoading >>>>" + this.payLoading);
            console.log("this.isPayed >>>>" + this.isPayed);
            //检查治疗单走 sqbTreatmentPay：回调按 TreatOrder 更新状态；sqbOrderPay 处理的是药品订单（MedicalOrder）
            clinicSqbTreatmentPay(JSON.stringify(params)).then(response => {
                console.log(response);
                this.isWaitPayLoading = false;
                this.payLoading = false;
                this.isPayed = true;
                this.applyPayResult(response, false);
            }).catch(error => {
                // AC13：请求异常一律回到「可重试」态，不能停留在等待扫码
                console.error('支付请求失败:', error);
                message("支付请求失败", "error");
                this.payLoading = false;
                this.isWaitPayLoading = true;
                this.isPayed = false;
                this.payState = "";
                this.payChannel = "";
            }).finally(() => {
                this.payRequesting = false;
            });
        },

        // 统一落地后端三态契约：200+success / 601+pending / 其他=明确失败
        applyPayResult(response, silent) {
            const data = (response && response.data) || {};
            const payState = data.payState;
            const channel = data.channel;
            if (response && response.code === 200 && payState === 'success') {
                this.payState = 'success';
                this.payChannel = channel || '';
                this.successPayed = true;
                this.stopPayPendingWatch();
                this.payPendingExpired = false;
                this.payErrorMsg = "";
                message(this.paySuccessText(channel), "success");
            } else if (response && response.code === 601 && payState === 'pending') {
                // AC3：第三态。既不得显示成功，也不得显示失败。
                this.payState = 'pending';
                this.payChannel = "";
                this.successPayed = false;
                if (!this.payPendingTimer && !this.payPendingExpired) {
                    // 首次进入 pending：开自动轮询窗口（与后端支付锁 TTL 对齐）
                    this.startPayPendingWatch();
                }
                this.payErrorMsg = this.payPendingExpired
                    ? this.pendingExpiredMessage()
                    : this.pendingMessage();
                if (!silent) {
                    message("支付结果确认中，请勿重复扫码", "warning");
                }
            } else {
                this.payState = 'failed';
                this.stopPayPendingWatch();
                this.payPendingExpired = false;
                this.payChannel = '';
                this.successPayed = false;
                this.payErrorMsg = (response && response.msg) || "支付失败";
                message(this.payErrorMsg, "error");
            }
        },

        paySuccessText(channel) {
            if (channel === 'CASH') {
                return "该订单已现金收款";
            }
            if (channel === 'FREE') {
                return "该订单为免费单，无需支付";
            }
            return "支付成功";
        },

        // AC3：pending 态的「重新查询」，只读接口，绝不发起扣款
        requeryPayResult(silent) {
            if (this.querying) {
                return;
            }
            this.querying = true;
            clinicSqbTreatQueryResult(this.treatOrderItem.treatId).then(response => {
                this.isWaitPayLoading = false;
                this.payLoading = false;
                this.isPayed = true;
                this.applyPayResult(response, silent);
            }).catch(error => {
                console.error('查询支付结果失败:', error);
                if (!silent) {
                    message("查询支付结果失败，请稍后重试", "error");
                }
            }).finally(() => {
                this.querying = false;
            });
        },

        /**
         * 开始 pending 自动轮询：每 PAY_PENDING_POLL_INTERVAL_SECONDS 秒查一次只读查单接口，
         * 最长 PAY_PENDING_WINDOW_SECONDS 秒；到点转「待人工核查」。
         *
         * 窗口到点后支付锁也随之过期，收银员可重新扫码 —— 重扫会先经后端
         * checkPreviousScanOrder：上一笔已 PAID 则直接报成功，仍是未定态则被保守拦截，
         * 因此「放行重扫」不会造成重复扣款。
         */
        startPayPendingWatch() {
            this.stopPayPendingWatch();
            this.payPendingExpired = false;
            this.payPendingRemain = PAY_PENDING_WINDOW_SECONDS;
            this.payPendingTimer = setInterval(() => {
                // 状态已被其他路径改写（成功/失败/重置）时窗口自行结束，
                // 这样各处的重置逻辑不必逐个记得清定时器
                if (this.payState !== 'pending') {
                    this.stopPayPendingWatch();
                    return;
                }
                this.payPendingRemain -= 1;
                if (this.payPendingRemain <= 0) {
                    this.stopPayPendingWatch();
                    this.markPayPendingExpired();
                    return;
                }
                this.payErrorMsg = this.pendingMessage();
                if (this.payPendingRemain % PAY_PENDING_POLL_INTERVAL_SECONDS === 0) {
                    // 自动轮询不弹 toast，避免每 10 秒打扰收银员一次
                    this.requeryPayResult(true);
                }
            }, 1000);
        },

        stopPayPendingWatch() {
            if (this.payPendingTimer) {
                clearInterval(this.payPendingTimer);
                this.payPendingTimer = null;
            }
        },

        // 窗口到点：转「待人工核查」。绝不能说成「支付失败」—— 钱可能已经收了。
        markPayPendingExpired() {
            this.payPendingExpired = true;
            this.payErrorMsg = this.pendingExpiredMessage();
            message(this.payErrorMsg, "warning");
        },

        pendingMessage() {
            return "支付结果确认中，请勿重复扫码（自动查询中，剩余 " + this.payPendingRemain + " 秒）";
        },

        pendingExpiredMessage() {
            return "支付结果超过 " + (PAY_PENDING_WINDOW_SECONDS / 60) + " 分钟仍未确认，请人工核查收钱吧流水";
        },

        // 替换原有的 initScanListener 方法
        initScanListener() {
            let barcode = '';
            let barcodeTimeout;

            // 只在支付等待界面启用扫码枪监听
            const handleKeyDown = (e) => {
                // 只在订单支付弹窗显示且正在等待扫码时处理
                if (!this.orderPayDialogVisible || !this.isWaitPayLoading) {
                    return;
                }

                // 检查目标元素是否为输入框，如果是则不处理（避免干扰正常输入）
                const target = e.target;
                if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
                    return;
                }

                console.log("e.key >>>> " + e.key);
                // 排除功能键
                if (e.key === 'Shift' || e.key === 'Control' || e.key === 'Alt') {
                    return;
                }

                // 清除之前的超时
                clearTimeout(barcodeTimeout);

                // 如果按下了回车键，表示扫码结束
                if (e.key === 'Enter') {
                    if (barcode.length > 0) {
                        if (barcode.indexOf("CapsLock") > -1) {
                            barcode = barcode.replace("CapsLock", "");
                        }
                        console.log('扫码完成barcode:', barcode);
                        this.handleScanCode(barcode);
                        barcode = ''; // 重置
                    }
                } else {
                    // 累加字符
                    barcode += e.key;
                }

                // 设置超时，如果在100ms内没有新的输入，则认为扫码完成
                barcodeTimeout = setTimeout(() => {
                    if (barcode.length > 0) {
                        console.log('扫码超时完成:', barcode);
                        barcode = ''; // 重置
                    }
                }, 100);
            };

            // 添加事件监听器
            document.addEventListener('keydown', handleKeyDown);

            // 保存移除监听器的函数，以便在组件销毁时调用
            this.removeScanListener = () => {
                document.removeEventListener('keydown', handleKeyDown);
            };
        },

        // 通过患者姓名获取患者列表
        queryPatiantListByName(queryName) {
            if (queryName !== "" && queryName !== null && queryName !== undefined) {
                this.treatOrderParams.patientName = queryName;
                // 修复：/docPatientProfile/listAll 不会自动按医生过滤，必须显式传当前医生ID，否则会搜到其他医生的患者
                // 注意：treatOrderParams.docId 会被治疗单列表查询覆写，这里显式覆盖为当前医生ID
                getPatientListByName({name: queryName, docId: getCurrentDoctorId()}).then(response => {
                    this.patientInfoList = [];
                    this.patientRange = [];
                    if (response.data.code === 200) {
                        this.patientInfoList = response.data.rows;
                        if (this.patientInfoList.length > 0) {
                            this.nameSelectConShow = true;
                            this.patientInfoList.forEach(item => {
                                this.patientRange.push({
                                    dppId: item.dppId,
                                    name: item.name,
                                    sex: item.sex === '0'?'男':item.sex === '1'?'女':'未知',
                                    age: item.age,
                                    identity: item.identity,
                                    isChoose: false,
                                });
                            })
                        } else {
                            this.nameSelectConShow = false;
                        }
                    } else {
                        this.nameSelectConShow = false;
                    }
                });
            } else {
                this.nameSelectConShow = false;
                this.treatOrder.dppId = null;
                this.currentPage = 1;
                this.getTreatHistoryOrderList();
            }
        },


        // 订单收费
        openPayScreen() {
            this.orderPayDialogVisible = true;
            this.payState = "";
            this.payChannel = "";
        },


        // 支付失败刷新重试
        cancalOrRefreshPay() {
            this.isWaitPayLoading = true;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.payErrorMsg = "";
            this.payState = "";
            this.payChannel = "";
        },


        // 打印待支付单据
        printPayInfo() {
            this.orderPayDialogVisible = false;
            this.isWaitPayLoading = true;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.payErrorMsg = "";
            this.payState = "";
            this.payChannel = "";
        },


        // 取消支付
        cancalPay() {
            this.orderPayDialogVisible = false;
            this.isWaitPayLoading = true;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.payErrorMsg = "";
            this.payState = "";
            this.payChannel = "";
        },



        // 确定选择患者
        sureChoosePatient(dppId, patientName) {
            this.treatOrder.dppId = dppId;
            this.treatOrderParams.patientName = patientName;
            this.patientRange.forEach(itm=>{
                itm.isChoose = dppId === itm.dppId;
            })
            this.nameSelectConShow = false;
            this.currentPage = 1;
            this.getTreatHistoryOrderList();
        },

        // 表格高度自适应
        resizeTableHeight() {
            setTimeout(()=>{
                if(this.$refs.multipleOrderTable){
                    this.$nextTick(() =>{
                        // 根据浏览器高度设置初始高度
                        //此处需要通过延迟方法来设置值，不然会出现值已更新，但页面没更新的问题
                        this.tableHeight = this.$refs.multipleOrderTable.clientHeight - 190;
                    })
                }
            }, 100)
        },

        // 选择时间
        chooseDateTime(){
            addDateRange(this.treatOrderParams, this.dateTime);
        },

        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },

        // 切换分页
        handleCurrentChange: function (val) {
            this.currentPage = val;
            this.getTreatHistoryOrderList();
        },

        // 切换分页
        handleSizeChange: function (val) {
            this.pageNums = val;
            this.getTreatHistoryOrderList();
        },

        /** 重置按钮操作 */
        resetQuery() {
            this.treatOrderParams.diagnosis = null;
            this.treatOrderParams.projectType = null;
            this.treatOrder.dppId = null;
            this.dateTime = [];
            addDateRange(this.treatOrderParams, this.dateTime);
            this.currentPage = 1;
            this.getTreatHistoryOrderList();
        },


        // 执行检查治疗项目
        executetreatOrderItemFunc(itemId, toId, projectName) {
            this.$confirm('确定要执行当前所选项目吗？', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                //根据工单类型筛选，已完成订单
                executetreatOrderItem(toId).then(response => {
                    console.log(response);
                    if (response.code === 200) {
                        message("所选的 " + projectName + " 项目执行成功！", "success");
                        this.qryryTreatItemList(itemId);
                    } else {
                        message("所选的 " + projectName + " 项目执行失败！原因：" + response.msg, "error");
                    }
                });
            }).catch(() => {
                console.log('用户取消切换');
            })
        },

        // 已执行提示
        executedFunc(projectName) {
            message("所选的 " + projectName + " 项目暂无法执行或已经执行完成，请核对后重试！", "warning");
        },


        // 查询检查治疗项目工单
        getTreatHistoryOrderList() {
            const doctorId = getCurrentDoctorId();
            const queryVersion = ++this.treatOrderQueryVersion;

            this.tableLoading = true;
            this.tableData = [];
            this.totalCount = 0;

            // 诊疗工单必须按当前登录医生过滤，不能使用详情对象中的 docId：
            // 首次查询和切换患者前该字段为空，容易查出其他医生的开方记录。
            if (!doctorId) {
                this.tableLoading = false;
                message("当前医生信息未加载，请刷新页面重试", "error");
                return;
            }

            const queryParams = {
                ...this.treatOrderParams,
                dppId: this.treatOrder.dppId,
                docId: doctorId,
                pageNum: this.currentPage,
                pageSize: this.pageNums
            };

            getTreatOrderAllList(queryParams).then(response => {
                if (queryVersion !== this.treatOrderQueryVersion) {
                    return;
                }
                console.log(response);
                this.tableLoading = false;
                if (response.data.code === 200) {
                    const rows = Array.isArray(response.data.rows) ? response.data.rows : [];
                    this.totalCount = response.data.total || 0;
                    this.tableData = rows;
                    if (this.tableData.length > 0) {
                        this.tableData.forEach(item=>{
                            item.isExpandRow = false;
                            item.isExecutedNum = 0;
                            if (item.treatOrderItemList.length > 0) {
                                item.treatOrderItemList.forEach(itm=>{
                                    if (itm.excuteStatus === '1') {
                                        item.isExecutedNum++;
                                    }
                                })
                            }
                            if (item.isExecutedNum === item.treatOrderItemList.length) {
                                item.isExecutedInfo = '2';
                                item.orderStatus = '3';
                            } else if (item.isExecutedNum === 0) {
                                item.isExecutedInfo = '0';
                            } else {
                                item.isExecutedInfo = '1';
                            }

                            if (item.dppSex === "1") {
                                item.avatarImg = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                            } else if (item.dppSex === "0") {
                                item.avatarImg = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                            } else {
                                item.avatarImg = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                            }
                        })
                    }
                }
            }).catch(error => {
                if (queryVersion !== this.treatOrderQueryVersion) {
                    return;
                }
                this.tableLoading = false;
                console.error("查询诊疗工单失败:", error);
                message("查询诊疗工单失败，请稍后重试", "error");
            });
        },


        // 打开详情展示弹窗
        expandRowDetail(items) {
            this.treatOrderDetailVisible = true;
            this.treatLoading = true;
            this.treatOrder = items;
            this.payCodeList = [];
            this.payCodeList.push(this.tencentCosUrl+items.payQrcode);
            this.treatOrderItem.treatId = items.id;
            getTreatOrderItemList(this.treatOrderItem).then(response => {
                console.log(response);
                this.treatLoading = false;
                this.treatItemData = [];
                if (response.data.code === 200) {
                    this.treatItemData = response.data.rows;
                }
            });
        },


        // 取消详情展示弹窗
        cancelTreatDetail() {
            this.treatOrderDetailVisible = false;
        },

        // 获取当前时间
        getDayDateNow() {
            let nowDate = new Date();
            let year = nowDate.getFullYear();
            let month = this.checkTime(nowDate.getMonth() + 1);
            let date = this.checkTime(nowDate.getDate());
            let hour = this.checkTime(nowDate.getHours());
            let minute = this.checkTime(nowDate.getMinutes());
            let second = this.checkTime(nowDate.getSeconds());
            return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
        },

        checkTime(a) {
            if (a < 10) {
                a = "0" + a;
            }
            return a;
        },

    }
}
